import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import { useState } from "react";

export default function AdminLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen flex" data-testid="admin-layout">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0 lg:ml-64">
        <main className="flex-1 p-6 md:p-8 animate-float-in" data-testid="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
